/**
 * Geometria e nomes do painel da conversa (§5.1; kill-switch
 * `PAINEL_PROGRESSO_CONTEXTO_ATIVO`). Uma fonte só para os componentes de
 * `components/painel-do-chat/`.
 */
export const STORE_DO_PAINEL = 'aawz-intelligence-v2'

// O cartão flutuante do canto tem largura FIXA dentro da faixa livre ao lado
// do trilho (não segue o texto). Faixa menor que o piso = não cabe: nasce
// recolhido e abre SOBREPOSTO ao clique.
export const LARGURA_MINIMA_DO_CARTAO = 200
export const LARGURA_MAXIMA_DO_CARTAO = 240

export function cabeCartaoNaFaixa(larguraMaxima) {
  if (larguraMaxima === null || larguraMaxima === undefined) return true
  return Number(larguraMaxima) >= LARGURA_MINIMA_DO_CARTAO
}

export function larguraDoCartao(larguraMaxima) {
  const faixa = Number(larguraMaxima)
  if (!faixa) return LARGURA_MAXIMA_DO_CARTAO
  return Math.min(LARGURA_MAXIMA_DO_CARTAO, Math.max(LARGURA_MINIMA_DO_CARTAO, faixa))
}

// Preferência "cartão recolhido" em `localStorage` (`'1'` = recolhido).
export const CHAVE_DO_RECOLHIDO_NO_STORAGE = 'iaChatPainelFlutuanteRecolhido'
export const MARCA_DE_RECOLHIDO = '1'

// O anel de progresso: raio + traço num viewBox de 20.
export const LADO_DO_ANEL = 20
export const RAIO_DO_ANEL = 8
export const TRACO_DO_ANEL = 2.5
// Fração do anel desenhada enquanto gira sem plano (indeterminado).
export const ARCO_INDETERMINADO = 0.28

export const ICONE_DE_CONCLUIDO = 'check-circle'
export const ICONE_DE_CONCLUIDAS_OCULTAS = 'check'
export const ICONE_DE_FALHA = 'error-circle'
export const ICONE_DE_AVANCAR = 'chevron-right'
export const ICONE_DE_RECOLHER = 'chevron-right'
export const ICONE_DE_EXPANDIR = 'chevron-left'
// O botão recolhido sem plano (só entregas).
export const ICONE_DAS_ENTREGAS = 'document-text'

// Ícones de módulo nas entregas e nos controles do cartão.
export const TAMANHO_DO_ICONE_DO_PAINEL = 16
export const TAMANHO_DO_ICONE_DA_ENTREGA = 14
export const TAMANHO_DO_ICONE_DO_CONTROLE = 14

// Encenação do Progresso (`progresso-encenado-mixin.js`): uma etapa a cada
// `DWELL`, com o turno inteiro no teto — com muitas etapas o intervalo encolhe
// até o piso. Só a EXIBIÇÃO; o turno, o texto e as entregas não esperam nada.
// Números afinados com o usuário (17/09/2026): mexer aqui é o botão de ritmo.
export const DWELL_DA_ENCENACAO_MS = 350
export const TETO_DA_ENCENACAO_MS = 2000
export const PISO_DA_ENCENACAO_MS = 200

// Respiro entre o fim da encenação do plano e a abertura automática do aside —
// sem ele o artefato aparece no mesmo quadro do último check, e a tela "pula".
export const ATRASO_DA_ABERTURA_AUTOMATICA_MS = 400

// Entregas: no máximo 3 linhas à vista (linha = tile 24 + 4px em cima e embaixo);
// o resto rola dentro da lista.
export const MAX_ENTREGAS_VISIVEIS = 3
export const ALTURA_DA_LINHA_DE_ENTREGA = 44

// No cartão, o Progresso mostra no máximo esta janela de etapas (`utils/janela-do-progresso.js`).
export const MAXIMO_DE_ETAPAS_VISIVEIS = 3

// Respiro do cartão (e do botão recolhido) no canto da área do chat: o MESMO
// valor do topo e da borda direita.
export const RESPIRO_DO_PAINEL_FLUTUANTE = 16

// O botão recolhido (36×36): com o aside aberto, faixa menor que ele = cartão oculto.
export const LADO_DO_BOTAO_RECOLHIDO = 36

export function cabeBotaoRecolhidoNaFaixa(larguraMaxima) {
  if (larguraMaxima === null || larguraMaxima === undefined) return true
  return Number(larguraMaxima) >= LADO_DO_BOTAO_RECOLHIDO
}
